<p-dropdown hideDropdownOnScroll [options]="mappedDashboards" [(ngModel)]="selectedDashboard" (onChange)="bubbleOnChange($event)" ></p-dropdown>
